import CampaignAnalyticsRoutes from "./campaignAnalyticsRoutes";
import CampaignLeadTrackRoutes from "./campaignLeadTrackRoutes";
import CampaignsRoutes from "./campaignsRoutes";
import CategoryRoutes from "./categoryRoutes";
import GroupsRoutes from "./groupsRoutes";
import ReportsRoutes from "./reportsRoutes";
import WalletAndBillingRoutes from "./walletAndBillingRoutes";

export default function MarketingBlastRoutes() {

  return (
    <>
      {ReportsRoutes}
      {CampaignAnalyticsRoutes}
      {CampaignLeadTrackRoutes}
      {CampaignsRoutes}
      {GroupsRoutes}
      {CategoryRoutes}
      {WalletAndBillingRoutes}
    </>
  )
}
